export const UPDATE_RESULTS_QSEB_SUCCESS = 'UPDATE_RESULTS_QSEB_SUCCESS';

export const updateResultsQsebSuccess = results => ({
    type: UPDATE_RESULTS_QSEB_SUCCESS,
    payload: { results },
});
